import { useState, useRef } from 'react'
import { useForm } from 'react-hook-form'
import { Row, Col } from '@ui/wrapper'
import { hasKey } from '@utils'
import { FormGroup, Input } from '@ui/form-elements'
import Button from '@ui/button'
import { StyledText, StyledText2 } from './style'
import { usePageContext } from '@context/PageContext'
import Alert from 'react-bootstrap/Alert'

const regexes = {
  email: /^[A-Z0-9._%+-]+@(?![.-])[A-Z0-9.-]+(?<![.-])\.[A-Z]{2,}$/i
}

const AnmeldungForm = ({ data, dataErrorMessages }) => {
  const urlParams = new URLSearchParams(window.location.search)
  const event = urlParams.get('event')

  const serverResponseRef = useRef(null)

  const disclaimerText = data.texts[1]?.content
  const successText = data.texts[2]?.content
  const maxRegistrationsText = data.texts[3]?.content

  const errorOccurredText = dataErrorMessages?.texts?.[1]?.content
  const alreadyRegisteredText = dataErrorMessages?.texts?.[2]?.content

  const formUrl = '/api/anmeldung'
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm()

  const [submitted, setSubmitted] = useState(false)
  const [serverState, setServerState] = useState({
    submitting: false,
    status: null
  })
  const handleServerResponse = (ok, msg, form) => {
    setServerState({
      submitting: false,
      status: { ok, msg }
    })
    if (ok) {
      form.reset()
      setSubmitted(true)
    }
  }

  const { locale } = usePageContext()

  const onSubmit = async (data, e) => {
    const form = e.target
    setServerState({ submitting: true })

    try {
      const res = await fetch(formUrl + `?locale=${locale}`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'x-event': event
        }
      })
      const r = res.ok ? await res.json() : { message: await res.text() }
      if (res.ok) {
        handleServerResponse(true, successText, form)
        return
      }

      serverResponseRef.current?.scrollIntoView({ behavior: 'smooth' })

      if (r.message === 'Conflict: Max registrations reached') {
        handleServerResponse(false, maxRegistrationsText || r.message, form)
      } else if (res.status === 409) {
        handleServerResponse(false, alreadyRegisteredText || r.message, form)
      } else {
        handleServerResponse(false, r.message, form)
      }
    } catch (error) {
      handleServerResponse(false, errorOccurredText || error.message, form)
    }
  }

  if (submitted) {
    return <StyledText2 dangerouslySetInnerHTML={{ __html: successText }} />
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <StyledText>
        <Row gutters={{ lg: 20 }}>
          {data.items?.map((item, i) => (
            <Col lg={item.count || 6} key={i}>
              <FormGroup mb="20px">
                <Input
                  type="text"
                  id={item.name}
                  placeholder={
                    item.texts[0]?.content ? item.title + '*' : item.title
                  }
                  feedbackText={errors[item.name]?.message}
                  state={hasKey(errors, item.name) ? 'error' : ''}
                  showState={!!hasKey(errors, item.name)}
                  {...register(item.name, {
                    required: item.texts[0]?.content,
                    pattern: item.texts[1]?.path && {
                      value: regexes[item.texts[1]?.path],
                      message: item.texts[1]?.content
                    }
                  })}
                />
              </FormGroup>
            </Col>
          ))}
        </Row>
        <Row>
          <Col lg={12} mb="20px">
            <div
              className="text-muted"
              dangerouslySetInnerHTML={{ __html: disclaimerText }}
            />
          </Col>
        </Row>
        <div ref={serverResponseRef} />
        {serverState.status && (
          <Row mt="20px">
            <Col lg={12}>
              <Alert variant={serverState.status.ok ? 'success' : 'danger'}>
                <div
                  dangerouslySetInnerHTML={{ __html: serverState.status.msg }}
                />
              </Alert>
            </Col>
          </Row>
        )}
        <Row>
          <Col lg={12}>
            <Button type="submit" disabled={serverState.submitting}>
              {data.buttons[0].content}
            </Button>
          </Col>
        </Row>
      </StyledText>
    </form>
  )
}

export default AnmeldungForm
